import React, { Dispatch, SetStateAction } from 'react';
import { ExpandLess, ExpandMore, SwitchAccessShortcut } from '@mui/icons-material';
import {
  Avatar,
  Badge,
  Box,
  IconButton,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Stack,
  Typography,
  Tooltip,
} from '@mui/material';
import avatar from '../../assets/img/default-avatar.png';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useSelector } from 'react-redux';
import { useModal } from 'hooks/useModal';
import { ModalsKeys, QueryResponse } from 'global';
import { useQuery } from '@apollo/client';
import {
  userAdditionalAccountsApi,
  AdditionalAccountsAPINameSpase,
  useUserAdditionalAccountsCheck,
} from 'modules/user/additionalAccounts';
import { RenderWithCondition } from '../shared/Conditional/RenderWithCondition';

interface Props {
  userName: string;
  isDrawerOpen: boolean;
  isCollapsed: boolean;
  userProfileMugshot: string;
  setIsCollapsed: Dispatch<SetStateAction<boolean>>;
  onNotificationsIconClick: () => void;
}

export const SidebarUserSection = ({
  isCollapsed,
  isDrawerOpen,
  setIsCollapsed,
  userName,
  userProfileMugshot,
  onNotificationsIconClick,
}: Props) => {
  const { handleOpen } = useModal(ModalsKeys.SwitchAccountDialog);
  const { hasAdditionalAccounts } = useUserAdditionalAccountsCheck();

  const portalNotifications = useSelector((state: any) => state.portalNotifications);

  const handeleNotificationIconClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onNotificationsIconClick();
  };

  return (
    <ListItem
      onClick={() => setIsCollapsed(prev => !prev)}
      disableGutters
      className="userSectionListItem"
      secondaryAction={
        <Stack direction={isDrawerOpen ? 'row' : 'column'} gap="0.5rem">
          <RenderWithCondition condition={hasAdditionalAccounts}>
            <Tooltip title="Switch Account">
              <IconButton
                size="small"
                className="notificationIconButton"
                onClick={event => {
                  event.stopPropagation();
                  handleOpen();
                }}
              >
                <SwitchAccessShortcut sx={{ color: 'white' }} fontSize="small" />
              </IconButton>
            </Tooltip>
          </RenderWithCondition>

          <IconButton className="notificationIconButton" onClick={handeleNotificationIconClick} size="small">
            <Badge badgeContent={portalNotifications.unreadCount} color="error" max={99}>
              <NotificationsIcon sx={{ color: 'white' }} fontSize="small" />
            </Badge>
          </IconButton>
        </Stack>
      }
    >
      <ListItemAvatar className="userAvatar">
        <Avatar alt="user logo" src={userProfileMugshot || avatar} className="userAvatarImage" />
      </ListItemAvatar>

      <ListItemText
        primary={
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography variant="body1" className="userNameText">
              {userName}
            </Typography>
            {isCollapsed ? <ExpandLess /> : <ExpandMore />}
          </Box>
        }
      />
    </ListItem>
  );
};
